<script lang="ts">
	import MarkdownContent from '$lib/components/docs/MarkdownContent.svelte';
	import type { PageData } from './$types';

	// Content is provided server-side (+page.server.ts) so the H1 is in the
	// prerendered HTML for crawlers.
	let { data }: { data: PageData } = $props();
	const content = $derived(data.content);
</script>

<svelte:head>
	<title>Contact Support - Heyweek Documentation</title>
	<meta name="description" content="Get help from Heyweek support team - live chat, email support, phone support for enterprise, and community resources." />
	<meta property="og:title" content="Contact Support - Heyweek Documentation" />
	<meta property="og:description" content="Get help from Heyweek support team - live chat, email support, phone support for enterprise, and community resources." />
</svelte:head>

<MarkdownContent {content} />